import { useEffect, useState } from 'react';
import './ProjectPage.scss';
import api from '../../utils/api';
import { Button, Container, Grid, Icon, Menu, MenuItem, Message as MessageSemantic } from 'semantic-ui-react';
import getTwoSymbols from '../../utils/getTwoSymbols';
import Project from '../../structures/project';
import CreateProjectPartModal from './components/CreateProjectPartModal/CreateProjectPartModal';
import ProjectPart from '../../structures/projectPart';
import { useParams } from 'react-router';
import { useNavigate } from "react-router";
import PartWorkspace from './components/PartWorkspace/PartWorkspace';

function ProjectPage() {
    const [projects, setProjects] = useState<Project[]>([])
    const [projectParts, setProjectParts] = useState<ProjectPart[]>([])
    const [isOpenCreateProjectPartModalOpen, setIsOpenCreateProjectPartModalOpen] = useState(false)
    const [isInventingParts, setIsInventingParts] = useState(false) 

    const { projectId, partId } = useParams() as { projectId: string, partId: string };
    const navigate = useNavigate()


    const inventParts = async () => {
        setIsInventingParts(true);
        await api.inventParts(projectId);
        await updateParts(projectId);
        setIsInventingParts(false);
    };

    const updateParts = async (projectId:string) => {
        api.getProjectParts(projectId).then(parts => {
            setProjectParts(parts); 
            if(parts.length > 0)
                if(parts.filter(x=>x.id == partId).length > 0){
                    //navigate(`/project/${projectId}/part/${parts[0].id}`)
                }else{
                    navigate(`/project/${projectId}/part/${parts[0].id}`)
                }
            else
                navigate(`/project/${projectId}`)
        })
    };
    useEffect(() => {
        (async () => {
            let projects = await api.getProjects();
            setProjects(projects);
            await updateParts(projectId);
        })()
    }, [])
    useEffect(()=> {
        (async () => {
            if(projectId != '')
                await updateParts(projectId);
        })()
    }, [projectId])
    const project = projects.filter(x=>x.id == projectId)[0];
    return (
        <div className='project-page'>
            <Grid style={{margin: '0', padding: '0'}} className='app'>
                <Grid.Row style={{margin: '0', padding: '0'}}>
                <Grid.Column width={2} className='menu' style={{height: 'calc(100vh - 60px)'}}>
                    {projectParts.length > 0 ? <>
                        <Menu pointing secondary vertical>
                        {projectParts.map((storyPart, index) =>{
                            return  <MenuItem
                            name={storyPart.name}
                            active={partId === storyPart.id}
                            onClick={() => {navigate(`/project/${projectId}/part/${storyPart.id}`)}}
                            ><span className='part-number'>{getTwoSymbols(index)}</span> {storyPart.name}</MenuItem>;
                            })}
                        </Menu>
                        <Button fluid icon size='tiny' onClick={()=>setIsOpenCreateProjectPartModalOpen(true)}><Icon name='plus'/> Добавить главу</Button>
                    </> : ''}
                </Grid.Column>
                <Grid.Column width={14} className='workspace'>
                    <Container>
                        {projectParts.length > 0 ? <PartWorkspace project={project} parts={projectParts} /> : <div className='message-fo-empty-parts'>
                            <MessageSemantic size='massive'>В этом проекте пока нет глав. Создайте главы вручную или сгенерируйте с помощью ИИ.</MessageSemantic>
                            <div className='btn-container'>
                                <Button disabled={isInventingParts} icon size='massive' onClick={()=>setIsOpenCreateProjectPartModalOpen(true)}><Icon name='plus'/> Добавить главу</Button>
                                <Button loading={isInventingParts} icon size='massive' primary onClick={inventParts}><Icon name='magic'/> Сгенерировать главы</Button>
                            </div>
                        </div>}
                    </Container>
                </Grid.Column>
                </Grid.Row>
            </Grid>
            <CreateProjectPartModal 
                open={isOpenCreateProjectPartModalOpen} 
                setOpen={setIsOpenCreateProjectPartModalOpen} 
                projectId={projectId}
                onSave={project => {
                    setIsOpenCreateProjectPartModalOpen(false); 
                    updateParts(projectId);
                }}/>
        </div>
        );
};

export default ProjectPage;